export default __webpack_public_path__ + "static/media/Skyshear Gauntlets.142c1047.jpg";